// extracted by mini-css-extract-plugin
export default {"input":"Search_input__tacYa","btn":"Search_btn__K0WKZ","container":"Search_container__0SfNG","sort":"Search_sort__E1DS5","shade":"Search_shade__VdZFB"};